import { render, staticRenderFns } from "./IdentityTemplate.vue?vue&type=template&id=5bdec3d9&scoped=true"
import script from "./IdentityTemplate.vue?vue&type=script&lang=js"
export * from "./IdentityTemplate.vue?vue&type=script&lang=js"
import style0 from "./IdentityTemplate.vue?vue&type=style&index=0&id=5bdec3d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdec3d9",
  null
  
)

export default component.exports